module.exports = __webpack_public_path__ + "static/media/fintech-logo-blue-version.959d548c.png";